"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultMouseEvent = /** @class */ (function () {
    function DefaultMouseEvent() {
    }
    DefaultMouseEvent.prototype.onMouseDown = function (e) {
        return true;
    };
    DefaultMouseEvent.prototype.onMouseEnter = function (e) {
        return true;
    };
    ;
    DefaultMouseEvent.prototype.onMouseLeave = function (e) {
        return true;
    };
    ;
    DefaultMouseEvent.prototype.onMouseMove = function (e) {
        return true;
    };
    ;
    DefaultMouseEvent.prototype.onMouseOut = function (e) {
        return true;
    };
    DefaultMouseEvent.prototype.onMouseOver = function (e) {
        return true;
    };
    DefaultMouseEvent.prototype.onMouseUp = function (e) {
        return true;
    };
    DefaultMouseEvent.prototype.onMouseWheel = function (e) {
        return true;
    };
    return DefaultMouseEvent;
}());
exports.DefaultMouseEvent = DefaultMouseEvent;
//# sourceMappingURL=DefaultMouseEvent.js.map